import Link from 'next/link';
import Image from 'next/image';

export default function BlogPostCard({ post }) {
  return (
    <div className="mb-12">
      <div className="mb-4">
        <Link href={post.link}>
          <div className="relative w-full h-64 lg:h-[500px] rounded-md overflow-hidden">
            <Image
              src={post.image}
              alt={`Modern Build Home Remodeling Post: ${post.title}`}
              title={post.title}
              fill
              sizes="(min-width: 1024px) 33vw, 100vw"
              className="object-cover rounded-md"
            />
          </div>
        </Link>
      </div>
      <div>
        <p className="text-sm text-gray mb-2">
          <span className="capitalize text-primary tracking-[3px]">
            {post.author} / {post.date}
          </span>
        </p>
        <h2 className="text-2xl font-light mb-3 font-gilda">
          <Link href={post.link}>{post.title}</Link>
        </h2>
        <p className="text-gray font-light mb-4">{post.excerpt}</p>
        {/* Featured In / Tags */}
        {post.tags?.length > 0 && (
          <div className="mb-6">
            <p className="text-xs uppercase tracking-[2px] text-gray">
              Featured In
            </p>

            <div className="flex flex-wrap gap-1">
              {post.tags.map((tag, idx) => (
                <span
                  key={idx}
                  className="text-xs text-gray"
                >
                  {tag},
                </span>
              ))}
            </div>
          </div>
        )}
        <Link href={post.link}>
          <button aria-label="read more" className="bg-primary text-white px-6 py-3 text-md tracking-[3px] uppercase hover:bg-black hover:text-white transition duration-300">
            Read More
          </button>
        </Link>
      </div>
    </div>
  );
}